import settings from '../../../config/settings'
import axios from '../api/axios'

export default class NotificationsApi {
  static list(page) {
    return axios.get(`${settings.apiBaseURL}/notifications?page=${page}`)
  }
}
